import { render, staticRenderFns } from "./AxSamlLogin.vue?vue&type=template&id=010004a4&scoped=true&"
import script from "./AxSamlLogin.vue?vue&type=script&lang=ts&"
export * from "./AxSamlLogin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010004a4",
  null
  
)

export default component.exports